// prd
// export const API_URL = "https://api.glemo.com.br/api"
// hml
export const API_URL = "https://api-hml.glemo.com.br/api"
// local
// export const API_URL = "https://localhost:7135/api"
export const MAIL_API_URL = 'http://frontend-glemo.web21f104.uni5.net/'
